document.addEventListener('click', (event) => {
  const link = event.target.closest('.m-nav-panel a, .m-desktop-submenu a');
  if (link) {
    const parentDisclosure = link.closest('details');
    if (parentDisclosure) parentDisclosure.open = false;
  }
  document.querySelectorAll('.m-drawer[open], .m-desktop-nav-group[open]').forEach((disclosure) => {
    if (!disclosure.contains(event.target)) disclosure.open = false;
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openDisclosures = document.querySelectorAll('.m-drawer[open], .m-desktop-nav-group[open]');
  if (openDisclosures.length === 0) return;
  openDisclosures.forEach((disclosure) => { disclosure.open = false; });
  openDisclosures[0].querySelector('summary')?.focus();
});

/* Shopify's locale-aware Predictive Search API enhances the native search forms. */
(() => {
  const cache = new Map();
  document.querySelectorAll('[data-predictive-search]').forEach((form) => {
    const input = form.querySelector('input[name="q"]');
    const panel = form.querySelector('[data-suggestions]');
    const list = form.querySelector('[data-suggestion-list]');
    const empty = form.querySelector('[data-suggestion-empty]');
    const viewAll = form.querySelector('[data-view-all]');
    const status = form.querySelector('[data-search-status]');
    let timer;
    let controller;
    let activeIndex = -1;
    let currentQuery = '';

    const currency = form.dataset.currency || 'INR';
    function money(amount) {
      const fractionDigits = Math.round(amount * 100) % 100 === 0 ? 0 : 2;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
          style: 'currency', currency, minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits
        }).format(amount);
      } catch (_) {
        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }).format(amount);
      }
    }

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
      list.querySelectorAll('[role="option"]').forEach((item) => item.setAttribute('aria-selected', 'false'));
    }

    function select(index) {
      const options = Array.from(list.querySelectorAll('[role="option"]'));
      if (!options.length) return;
      activeIndex = (index + options.length) % options.length;
      options.forEach((item, itemIndex) => item.setAttribute('aria-selected', String(itemIndex === activeIndex)));
      input.setAttribute('aria-activedescendant', options[activeIndex].id);
      options[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    function render(products, query) {
      list.replaceChildren();
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      const searchUrl = new URL(form.action, window.location.origin);
      searchUrl.searchParams.set('q', query);
      searchUrl.searchParams.set('type', 'product');
      viewAll.href = searchUrl.toString();

      products.forEach((product, index) => {
        const item = document.createElement('li');
        item.id = `${list.id}-option-${index}`;
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');
        const link = document.createElement('a');
        link.href = product.url;
        const imageUrl = product.featured_image?.url || product.image;
        if (imageUrl) {
          const image = document.createElement('img');
          const sizedUrl = new URL(imageUrl, window.location.origin);
          sizedUrl.searchParams.set('width', '100');
          image.src = sizedUrl.toString();
          image.alt = '';
          image.loading = 'lazy';
          link.append(image);
        }
        const copy = document.createElement('span');
        copy.className = 'm-suggestion-copy';
        const title = document.createElement('strong');
        title.textContent = product.title;
        copy.append(title);
        const price = Number(product.price_min ?? product.price);
        if (Number.isFinite(price)) {
          const amount = document.createElement('small');
          amount.textContent = money(price);
          copy.append(amount);
        }
        link.append(copy);
        item.append(link);
        list.append(item);
      });
      empty.hidden = products.length > 0;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      status.textContent = products.length > 0 ? form.dataset.resultsLabel : form.dataset.noResults;
    }

    async function request(query) {
      controller?.abort();
      controller = new AbortController();
      currentQuery = query;
      if (cache.has(query)) {
        render(cache.get(query), query);
        return;
      }
      try {
        const url = new URL(form.dataset.predictiveUrl, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Predictive search ${response.status}`);
        const payload = await response.json();
        if (currentQuery !== query || input.value.trim() !== query) return;
        const products = payload.resources?.results?.products || [];
        cache.set(query, products);
        if (cache.size > 40) cache.delete(cache.keys().next().value);
        render(products, query);
      } catch (error) {
        if (error.name !== 'AbortError') {
          close();
          status.textContent = '';
        }
      }
    }

    function schedule() {
      clearTimeout(timer);
      controller?.abort();
      const query = input.value.trim();
      if (query.length < 2) {
        currentQuery = '';
        close();
        status.textContent = '';
        return;
      }
      if (cache.has(query)) request(query);
      else {
        close();
        status.textContent = '';
        timer = setTimeout(() => request(query), 180);
      }
    }

    input.addEventListener('input', schedule);
    input.addEventListener('focus', () => {
      const query = input.value.trim();
      if (query.length >= 2) schedule();
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (!panel.hidden) { event.preventDefault(); close(); }
        return;
      }
      if (panel.hidden) return;
      const options = list.querySelectorAll('[role="option"]');
      if (event.key === 'ArrowDown' && options.length) { event.preventDefault(); select(activeIndex + 1); }
      if (event.key === 'ArrowUp' && options.length) { event.preventDefault(); select(activeIndex - 1); }
      if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        window.location.assign(options[activeIndex].querySelector('a').href);
      }
    });
    form.addEventListener('submit', (event) => {
      if (!panel.hidden && activeIndex >= 0) {
        event.preventDefault();
        const link = list.querySelectorAll('[role="option"]')[activeIndex]?.querySelector('a');
        if (link) window.location.assign(link.href);
      }
    });
    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); close(); input.focus(); }
    });
    document.addEventListener('click', (event) => { if (!form.contains(event.target)) close(); });
    document.addEventListener('focusin', (event) => { if (!form.contains(event.target)) close(); });
  });
})();
